// extracted by mini-css-extract-plugin
export default {"breadcrumb":"Breadcrumb_breadcrumb__mu1n4","teamItem":"Breadcrumb_teamItem__6Xedr","teamIcon":"Breadcrumb_teamIcon__3mqc3"};